/**
 * Decodes the payload of a JWT token (without verifying signature).
 * Signature verification is the server's responsibility.
 */
export function decodeToken(token) {
    try {
        const base64Payload = token.split(".")[1];
        const json = atob(base64Payload.replace(/-/g, "+").replace(/_/g, "/"));
        return JSON.parse(json);
    } catch {
        return null;
    }
}

/**
 * Returns true if the token is missing, malformed, or past its `exp` claim.
 */
export function isTokenExpired(token) {
    if (!token) return true;
    const payload = decodeToken(token);
    if (!payload?.exp) return true;
    // exp is in seconds; Date.now() is in milliseconds
    return payload.exp * 1000 < Date.now();
}
